type CandidateStats = { candidateType?: string; address?: string };

type PairStats = {
  type: string;
  state?: string;
  nominated?: boolean;
  localCandidateId?: string;
  remoteCandidateId?: string;
  currentRoundTripTime?: number;
};

type TransportStats = { type: string; selectedCandidatePairId?: string };

type StatsReport = {
  values: () => Iterable<any>;
  get: (id: string) => any | undefined;
};

export type WebrtcStatsPayload = {
  localCandidateType?: string;
  remoteCandidateType?: string;
  roundTripTimeMs?: number;
  relayAddress?: string;
};

export function readSelectedCandidatePair(
  stats: StatsReport | undefined | null,
): WebrtcStatsPayload {
  if (!stats) return {};

  const entries = [...stats.values()];
  const transport = entries.find((entry: TransportStats) => entry.type === "transport");
  const pair: PairStats | undefined =
    (transport?.selectedCandidatePairId
      ? stats.get(transport.selectedCandidatePairId)
      : undefined) ??
    entries.find(
      (entry: PairStats) =>
        entry.type === "candidate-pair" && entry.state === "succeeded" && entry.nominated,
    );
  if (!pair) return {};

  const local: CandidateStats | undefined = pair.localCandidateId
    ? stats.get(pair.localCandidateId)
    : undefined;
  const remote: CandidateStats | undefined = pair.remoteCandidateId
    ? stats.get(pair.remoteCandidateId)
    : undefined;

  return {
    localCandidateType: local?.candidateType,
    remoteCandidateType: remote?.candidateType,
    roundTripTimeMs:
      typeof pair.currentRoundTripTime === "number"
        ? Math.round(pair.currentRoundTripTime * 1000)
        : undefined,
    relayAddress:
      local?.candidateType === "relay"
        ? local.address
        : remote?.candidateType === "relay"
          ? remote.address
          : undefined,
  };
}

export function readIceServersHost(iceServers: any[] | undefined | null): {
  iceServersHost?: string;
  iceServersSource: string;
} {
  const turnUrl = (iceServers ?? [])
    .flatMap((server) => server?.urls ?? [])
    .map((url) => String(url))
    .find((url) => /^turns?:/.test(url));

  if (!turnUrl) return { iceServersSource: "fallback" };

  return {
    iceServersHost: turnUrl.split(":")[1]?.split(/[?/]/)[0],
    iceServersSource: "fetched",
  };
}
